import { Component, OnInit, Inject } from '@angular/core';
import { ErrorStateMatcher } from '@angular/material/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ConfirmComponent } from '../../shared/dialogs/confirm/confirm.component';
import { MustMatch } from '../../shared/validators/mustmatch-validator';
import { AccountService } from '../../services/account.service';
import { AuthService } from '../../services/auth.service';
import { Account } from '../../models/account';
import { SnackBarIconService } from '../../shared/snack-bar-icon/snack-bar-icon.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class AccountErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-profile-dialog',
  templateUrl: './account-profile.component.html',
  styleUrls: ['./account-profile.component.scss'],
  entryComponents: [
    ConfirmComponent
  ]
})

export class AccountProfileComponent implements OnInit {

  public matcher = new AccountErrorStateMatcher();
  public accountForm: FormGroup;   // store User Form
  public claims: any = { admin: false, operator: false, user: false } // store user permissions
  public spinner: boolean = false;

  constructor(
    private fb: FormBuilder,
    public _accountsService: AccountService,
    public _authService: AuthService,
    private snackBar: SnackBarIconService,
    @Inject(MAT_DIALOG_DATA) public data: Account
  ) { }

  ngOnInit() {
    // get user permissions
    this.currentClaims()
    // create user form
    this.accountForm = this.createForm()
    // populate the form
    this.setFormValues(this.data, this.accountForm)
  }

  currentClaims() {
    this._authService.currentClaims()
      .then(
        (result) => {
          this.claims.admin = result.claims.admin;
          this.claims.operator = result.claims.operator;
          this.claims.user = result.claims.user;
        }
      )
  }

  update() {
    if (this.accountForm.valid) {
      this.spinner = true;
      let account: Account = this.createUser(this.accountForm.value);
      this._accountsService.update(account)
        .then(() => {
          if (this._accountsService.objectImage) {
            this._accountsService.uploadImage(this._accountsService.objectImage, account.id)
          }
          this.snackBar.openSnackBar("Sucesso!", '', 'success');
        })
        .catch((error) => {
          console.log("user update error: " + JSON.stringify(error))
          let msgError: string = this._accountsService.makeMsgError(error.details.code)
          this.snackBar.openSnackBar(msgError, '', 'error');
        })
        .finally(() => {
          this.spinner = false         
        });
    }
  }

  createForm() {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      email: new FormControl('', [Validators.required, Validators.email]),
      displayName: new FormControl('', [Validators.required]),
      //phoneNumber: new FormControl('', [Validators.required]),
      photoURL: new FormControl(''),
      disabled: new FormControl(''),
      password: new FormControl(''),
      confirm: new FormControl(''),
      claim_admin: new FormControl(''),
      claim_operator: new FormControl(''),
      claim_user: new FormControl('')
    }, { validator: MustMatch('password', 'confirm') });

    return form
  }

  createUser(data: any): Account {

    let user = new Account()
    user.id = data.id;
    user.email = data.email;
    user.displayName = data.displayName;

    if (data.photoURL)
      user.photoURL = data.photoURL
    else
      user.photoURL = 'https://firebasestorage.googleapis.com/v0/b/saude-plena-v2.appspot.com/o/photoURL%2FphotoURL.png?alt=media&token=b402ff00-8219-45b9-b60c-8e624e1bf560';

    //user.phoneNumber = data.phoneNumber;
    user.disabled = data.disabled;
    user.password = data.password;
    //user.confirm = data.password;
    user.claim_admin = data.claim_admin;
    user.claim_operator = data.claim_operator;
    user.claim_user = true;

    return user;
  }

  setFormValues(data, form) {

    form.controls.id.setValue(data.id);
    form.controls.email.setValue(data.email);
    form.controls.displayName.setValue(data.displayName);
    form.controls.photoURL.setValue(data.photoURL);
    //form.controls.phoneNumber.setValue(data.phoneNumber);
    form.controls.disabled.setValue(data.disabled);
    form.controls.password.setValue("");
    form.controls.confirm.setValue("");
    form.controls.claim_admin.setValue(data.claim_admin);
    form.controls.claim_operator.setValue(data.claim_operator);
    form.controls.claim_user.setValue(data.claim_user);

    this._accountsService.storedImage = data.photoURL
  }

}
